import { useContext } from 'react';
import { UiTrackingContext } from '../context';

export const useTrackingContext = () => useContext(UiTrackingContext);
